import React from 'react'
import './Home.scss'

import Header from '../../components/Header/Header'
import Slider from '../../components/Slider/Slider'
import OurActivities from '../../components/OurActivities/OurActivities'
import OurProducts from '../../components/OurProducts/OurProducts'
import AboutUs from '../../components/AboutUs/AboutUs'
import Promotion from '../../components/Promotion/Promotion'
import LogoPartner from '../../components/LogoPartner/LogoPartner'
import Footer from '../../components/Footer/Footer'

export default function Home() {
  return (
    <div>
      <Header page={'home'} />
      <Slider />
      <OurActivities />
      <OurProducts />
      <AboutUs />
      <Promotion />
      <LogoPartner />
      <Footer/>
    </div>
  )
}
